import React, { useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Flame, TrendingUp, Loader2 } from "lucide-react";
import { AuraRing } from "@/components/brand/AuraRing";
import { VerifiedBadge } from "@/components/brand/VerifiedBadge";
import { usePoll } from "@/hooks/usePoll";
import { api, mediaUrl, auraFmt } from "@/lib/api";
import { cn } from "@/lib/utils";

export default function Leaderboard() {
  const navigate = useNavigate();
  const [rows, setRows] = useState(null);
  const load = useCallback(async () => { try { setRows(await api.auraLeaderboard()); } catch { setRows([]); } }, []);
  usePoll(load, 20000, []);

  return (
    <div className="mx-auto max-w-2xl px-4 py-5 md:px-6">
      <div className="mb-5 flex items-center gap-3">
        <span className="grid h-11 w-11 place-items-center rounded-2xl aura-gradient"><Flame className="h-6 w-6 text-black" /></span>
        <div>
          <h1 className="font-display text-2xl font-extrabold text-white">Fresh Aura</h1>
          <p className="text-sm text-am-text2">Who's gaining the most Aura in the last 24 hours.</p>
        </div>
      </div>

      {rows === null ? (
        <div className="flex justify-center py-20"><Loader2 className="h-6 w-6 animate-spin text-am-text3" /></div>
      ) : rows.length === 0 ? (
        <div className="py-20 text-center">
          <p className="text-sm font-semibold text-white">No momentum yet.</p>
          <p className="mt-1 text-xs text-am-text2">When people start earning Aura from posts, likes, comments and follows, they'll rank here.</p>
        </div>
      ) : (
        <div className="space-y-2">
          {rows.map((u, i) => (
            <button key={u.user_id} onClick={() => navigate(`/u/${u.username}`)} data-testid={`fresh-${u.username}`} className="flex w-full items-center gap-3 rounded-2xl border border-am-border bg-am-surface p-3 text-left transition-colors hover:bg-white/5">
              <span className={cn("w-6 shrink-0 text-center font-display text-lg font-extrabold", i === 0 ? "aura-text" : i < 3 ? "text-white" : "text-am-text3")}>{i + 1}</span>
              <AuraRing src={mediaUrl(u.picture) || undefined} size={44} ring={2} fallback={u.name} />
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-1 text-sm font-semibold text-white">{u.name}{u.is_verified && <VerifiedBadge size={13} />}</div>
                <div className="truncate text-xs text-am-text2">@{u.username}</div>
              </div>
              <div className="shrink-0 text-right">
                <div className="flex items-center gap-1 text-sm font-bold text-aura-mint"><TrendingUp className="h-3.5 w-3.5" /> {auraFmt(u.gained_centi)}</div>
                <div className="text-[10px] text-am-text3">Aura · 24h</div>
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
